import { Initialize } from 'pacto';
import { Formfield as View } from '../views/Formfield';


export class Action extends Initialize {
  get settings() {
    return {
      selector: `
        .formfield input:not([type="radio"]),
        .formfield textarea,
        .formfield select,
        .formfield button
      `,
      namespace: 'formfield:views',
      view: View,
    };
  }
}
